// Textos y helpers de display del modo de posición (HEDGE/ONE_WAY) de una
// cuenta de exchange -- WP-wizard-exchange-modos
// (docs/specs/Spec_Wizard_Exchange_Modos.md §2.1/§2.2). Único sitio de copy:
// el formulario de alta, el diálogo de edición y el wizard leen de aquí, de
// modo que ninguna pantalla vuelva a afirmar que solo se soporta one-way.

/** Verdad operativa (§2.1): el engine lee el modo en caliente y adapta cada orden. */
export const POSITION_MODE_TRUTH =
  'Quantum opera con tu cuenta tal como esté configurada en Bitunix (one-way o hedge) — ' +
  'el motor detecta el modo y adapta cada orden. Recomendación: hedge si vas a correr varios ' +
  'bots en la misma cuenta; en one-way, bots en el mismo símbolo se netean.'

export function targetPositionMode(mode) {
  return mode === 'HEDGE' ? 'ONE_WAY' : 'HEDGE'
}

/** Wizard (solo lectura, §2.2.3): el cambio se hace editando la cuenta. */
export function wizardPositionModeText(mode) {
  return (
    `Modo de posición de esta cuenta: ${mode} — afecta a todos los bots de la cuenta. ` +
    'Para cambiarlo: edita la cuenta (requiere 0 posiciones abiertas).'
  )
}

/** Aviso previo al cambio (confirm estándar, §2.2.2). */
export function positionModeChangeWarning(mode, target) {
  return (
    `¿Cambiar el modo de posición de ${mode} a ${target}? Esto afecta a TODOS los bots de esta ` +
    'cuenta y requiere 0 posiciones abiertas en cualquier símbolo. Si hay alguna abierta, el ' +
    'cambio se rechazará y verás cuáles la impiden.'
  )
}

/** Mensaje del backend (409 con los símbolos bloqueantes incluido) tal cual; cubre axios (`response.data`) y publicApi (`body`). */
export function positionModeErrorMessage(err, fallback = 'Error al cambiar el modo de posición') {
  const detail = err?.body?.detail ?? err?.response?.data?.detail
  return typeof detail === 'string' && detail ? detail : fallback
}
